// Generated by purs version 0.15.15
import * as Data_Function from "../Data.Function/index.js";
import * as Record from "../Record/index.js";
var merge = /* #__PURE__ */ Record.merge()();
var fromDefaults1 = function () {
    return function () {
        return {
            fromDefaults: Data_Function.flip(merge)
        };
    };
};
var mkNamedParamsFn$prime = function () {
    return function () {
        return function (defaults) {
            return function (impl) {
                return function (params) {
                    return impl(merge(params)(defaults(params)));
                };
            };
        };
    };
};
var mkNamedParamsFn = function () {
    return function () {
        return function (defaults) {
            return function (impl) {
                return function (params) {
                    return impl(merge(params)(defaults));
                };
            };
        };
    };
};
var fromDefaults = function (dict) {
    return dict.fromDefaults;
};
export {
    fromDefaults,
    mkNamedParamsFn,
    mkNamedParamsFn$prime,
    fromDefaults1
};
